import React from "react";
import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ColumnOne from "./ColumnOne";
import ColumnTwo from "./ColumnTwo";

const useStyles = makeStyles(theme => ({
  borderLeft: {
    borderLeft: "1px solid #cacaca",
    paddingLeft: "12px!important",
  },
}));

const AboutSectionReadOnly = ({ userDetails }) => {
  const classes = useStyles();
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={6}>
        <ColumnOne userDetails={userDetails} />
      </Grid>
      <Grid item xs={12} md={6} className={classes.borderLeft}>
        <ColumnTwo userDetails={userDetails} />
      </Grid>
    </Grid>
  );
};

export default AboutSectionReadOnly;
